import React from 'react'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'

import HeaderPrimary from 'components/header-primary/header-primary'
import HeaderMobilePrimary from 'components/header-primary/header-mobile-primary'
import Subscribe from 'components/subscribe/subscribe'
import Footer from 'components/footer/footer'

import HomeContent from 'views/main/home/home-content'

const siteImage = safeSiteData.site_featured_image_url
const siteImageSrcset = safeSiteData.site_featured_image_srcset

class SiteLayout extends React.Component {
	render() {
		return (
			<div>
				<HeaderMobilePrimary />

				<div className="main-wrap">
					<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

					<HeaderPrimary />

					<HomeContent />
				</div>

				<Subscribe />

				<Footer />
			</div>
		)
	}
}

export default SiteLayout



// WEBPACK FOOTER //
// ./views/layouts/main/home-layout.jsx